import type { SVGProps } from "react";
export default function SvgGenericApp(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			viewBox="0 0 148 192"
			{...props}
		>
			<g filter="url(#filter0_ddddi_1094_1425)">
				<path
					fill="url(#paint0_linear_1094_1425)"
					fillOpacity={0.6}
					stroke="url(#paint1_linear_1094_1425)"
					d="M44.842 22.959h48.414a4.34 4.34 0 0 1 4.342 4.342v69.857a4.34 4.34 0 0 1-4.342 4.342H44.842a4.34 4.34 0 0 1-4.342-4.342V27.301a4.34 4.34 0 0 1 4.342-4.342Z"
				/>
			</g>
			<g filter="url(#filter1_ddddi_1094_1425)">
				<path
					fill="white"
					fillOpacity={0.01}
					d="M107.337 33.836v54.86a4.84 4.84 0 0 1-4.842 4.843H54.081a4.84 4.84 0 0 1-4.842-4.842V18.842A4.84 4.84 0 0 1 54.081 14H87.52l19.814 19.836z"
				/>
				<path
					stroke="url(#paint2_linear_1094_1425)"
					strokeOpacity={0.5}
					d="M54.081 14.5h33.232l19.524 19.545v54.651a4.34 4.34 0 0 1-4.342 4.343H54.081a4.34 4.34 0 0 1-4.342-4.343V18.842a4.34 4.34 0 0 1 4.342-4.342Z"
				/>
			</g>
			<g filter="url(#filter2_ddddi_1094_1425)">
				<path
					fill="white"
					fillOpacity={0.01}
					stroke="url(#paint3_linear_1094_1425)"
					d="M106.198 33.439H92.681a4.68 4.68 0 0 1-4.683-4.675V15.208z"
				/>
			</g>
			<path
				fill="#FAFF00"
				d="M97.43 49.268H59.15a2.114 2.114 0 1 1 0-4.23h38.282a2.114 2.114 0 1 1 0 4.23z"
			/>
			<path
				fill="#FAFF00"
				d="M97.43 62.046H59.15a2.114 2.114 0 1 1 0-4.23h38.282a2.114 2.114 0 1 1 0 4.23z"
			/>
			<path
				fill="#FAFF00"
				d="M97.43 74.824H59.15a2.114 2.114 0 1 1 0-4.23h38.282a2.114 2.114 0 1 1 0 4.23z"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_1094_1425"
					x1={69.1971}
					x2={69.1971}
					y1={22.459}
					y2={102}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F5FCFF" />
					<stop offset={1} stopColor="#BBD3DD" />
				</linearGradient>
				<linearGradient
					id="paint1_linear_1094_1425"
					x1={69.0489}
					x2={34.0006}
					y1={23.3301}
					y2={80.2203}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="white" />
					<stop offset={0.519231} stopColor="#A6BEC4" />
					<stop offset={1} stopColor="white" />
				</linearGradient>
				<linearGradient
					id="paint2_linear_1094_1425"
					x1={78.2882}
					x2={78.2882}
					y1={14}
					y2={93.5387}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F5FCFF" />
					<stop offset={0.509653} stopColor="#B1D2DB" />
					<stop offset={1} stopColor="#F5FCFF" />
				</linearGradient>
				<linearGradient
					id="paint3_linear_1094_1425"
					x1={97.4529}
					x2={90.0841}
					y1={14.2184}
					y2={30.5707}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="white" />
					<stop offset={0.519231} stopColor="#A6BEC4" />
					<stop offset={1} stopColor="white" />
				</linearGradient>
				<filter
					id="filter0_ddddi_1094_1425"
					width={138.098}
					height={187.541}
					x={0}
					y={4.45898}
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={10} />
					<feGaussianBlur stdDeviation={12} />
					<feColorMatrix values="0 0 0 0 0.419608 0 0 0 0 0.658824 0 0 0 0 0.717647 0 0 0 0.1 0" />
					<feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1094_1425" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={40} />
					<feGaussianBlur stdDeviation={20} />
					<feColorMatrix values="0 0 0 0 0.419608 0 0 0 0 0.658824 0 0 0 0 0.717647 0 0 0 0.09 0" />
					<feBlend
						in2="effect1_dropShadow_1094_1425"
						result="effect2_dropShadow_1094_1425"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={50} />
					<feGaussianBlur stdDeviation={15} />
					<feColorMatrix values="0 0 0 0 0.0620791 0 0 0 0 0.165757 0 0 0 0 0.220065 0 0 0 0.02 0" />
					<feBlend
						in2="effect2_dropShadow_1094_1425"
						result="effect3_dropShadow_1094_1425"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={50} />
					<feGaussianBlur stdDeviation={20} />
					<feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0" />
					<feBlend
						in2="effect3_dropShadow_1094_1425"
						result="effect4_dropShadow_1094_1425"
					/>
					<feBlend in="SourceGraphic" in2="effect4_dropShadow_1094_1425" result="shape" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={-1} />
					<feGaussianBlur stdDeviation={2.5} />
					<feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
					<feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
					<feBlend in2="shape" result="effect5_innerShadow_1094_1425" />
				</filter>
				<filter
					id="filter1_ddddi_1094_1425"
					width={138.098}
					height={187.539}
					x={9.23926}
					y={-4}
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={10} />
					<feGaussianBlur stdDeviation={12} />
					<feColorMatrix values="0 0 0 0 0.419608 0 0 0 0 0.658824 0 0 0 0 0.717647 0 0 0 0.1 0" />
					<feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1094_1425" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={40} />
					<feGaussianBlur stdDeviation={20} />
					<feColorMatrix values="0 0 0 0 0.419608 0 0 0 0 0.658824 0 0 0 0 0.717647 0 0 0 0.09 0" />
					<feBlend
						in2="effect1_dropShadow_1094_1425"
						result="effect2_dropShadow_1094_1425"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={50} />
					<feGaussianBlur stdDeviation={15} />
					<feColorMatrix values="0 0 0 0 0.0620791 0 0 0 0 0.165757 0 0 0 0 0.220065 0 0 0 0.02 0" />
					<feBlend
						in2="effect2_dropShadow_1094_1425"
						result="effect3_dropShadow_1094_1425"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={50} />
					<feGaussianBlur stdDeviation={20} />
					<feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0" />
					<feBlend
						in2="effect3_dropShadow_1094_1425"
						result="effect4_dropShadow_1094_1425"
					/>
					<feBlend in="SourceGraphic" in2="effect4_dropShadow_1094_1425" result="shape" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={-1} />
					<feGaussianBlur stdDeviation={2.5} />
					<feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
					<feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
					<feBlend in2="shape" result="effect5_innerShadow_1094_1425" />
				</filter>
				<filter
					id="filter2_ddddi_1094_1425"
					width={99.9097}
					height={127.938}
					x={47.498}
					y={-4}
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={10} />
					<feGaussianBlur stdDeviation={12} />
					<feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
					<feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1094_1425" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={40} />
					<feGaussianBlur stdDeviation={20} />
					<feColorMatrix values="0 0 0 0 0.027451 0 0 0 0 0.109804 0 0 0 0 0.152941 0 0 0 0.09 0" />
					<feBlend
						in2="effect1_dropShadow_1094_1425"
						result="effect2_dropShadow_1094_1425"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={50} />
					<feGaussianBlur stdDeviation={15} />
					<feColorMatrix values="0 0 0 0 0.0620791 0 0 0 0 0.165757 0 0 0 0 0.220065 0 0 0 0.02 0" />
					<feBlend
						in2="effect2_dropShadow_1094_1425"
						result="effect3_dropShadow_1094_1425"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={50} />
					<feGaussianBlur stdDeviation={20} />
					<feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0" />
					<feBlend
						in2="effect3_dropShadow_1094_1425"
						result="effect4_dropShadow_1094_1425"
					/>
					<feBlend in="SourceGraphic" in2="effect4_dropShadow_1094_1425" result="shape" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={-1} />
					<feGaussianBlur stdDeviation={2.5} />
					<feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
					<feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
					<feBlend in2="shape" result="effect5_innerShadow_1094_1425" />
				</filter>
			</defs>
		</svg>
	);
}
